module.exports = __webpack_public_path__ + "static/media/shiftshave-replacement-blade-1.821f6c65.jpg";